import React, { useEffect, useRef } from 'react';

/**
 * Rückfrage vor einer folgenreichen Handlung, im Stil der Seite statt `window.confirm`
 * (30.10.2026, zuerst für „Abmelden“ im Profil). Am Handy ein Blatt von unten, am Rechner ein
 * kleines Fenster. Der Fokus liegt auf „Abbrechen“, Escape und ein Tipp daneben schließen: ein
 * versehentlicher Doppeltipp soll nie die Handlung auslösen.
 */
export interface RueckfrageProps {
  offen: boolean;
  titel: string;
  text?: string;
  bestaetigen: string;
  /** Rote statt Beeren-Schaltfläche, für Löschen und Ähnliches. */
  gefahr?: boolean;
  onBestaetigen: () => void;
  onAbbrechen: () => void;
}

const Rueckfrage: React.FC<RueckfrageProps> = ({ offen, titel, text, bestaetigen, gefahr, onBestaetigen, onAbbrechen }) => {
  const abbrechenRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!offen) return;
    // Fokus für Screenreader und Tastatur, ohne Rahmen nach einem Tipp (focusVisible: false).
    abbrechenRef.current?.focus({ focusVisible: false } as FocusOptions);
    const taste = (e: KeyboardEvent) => { if (e.key === 'Escape') onAbbrechen(); };
    document.addEventListener('keydown', taste);
    return () => document.removeEventListener('keydown', taste);
  }, [offen, onAbbrechen]);
  if (!offen) return null;
  return (
    <div className="rq-hintergrund" onClick={onAbbrechen}>
      <div className="rq-blatt" role="alertdialog" aria-modal="true" aria-labelledby="rq-titel"
        aria-describedby={text ? 'rq-text' : undefined} onClick={e => e.stopPropagation()}>
        <h2 id="rq-titel" className="rq-titel">{titel}</h2>
        {text && <p id="rq-text" className="rq-text">{text}</p>}
        <div className="rq-knoepfe">
          <button ref={abbrechenRef} type="button" className="rq-abbrechen" onClick={onAbbrechen}>Abbrechen</button>
          <button type="button" className={gefahr ? 'rq-ok rq-ok--gefahr' : 'rq-ok'} onClick={onBestaetigen}>{bestaetigen}</button>
        </div>
      </div>
    </div>
  );
};

export default Rueckfrage;
